// extracted by mini-css-extract-plugin
export default {"aboutBg":"Recruit_aboutBg__nGIiq"};